import * as React from "react"
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./tooltip"

interface TextTooltipProps {
  title: string | React.ReactNode
  children?: React.ReactNode
  side?: "top" | "right" | "bottom" | "left"
  align?: "start" | "center" | "end"
}

const TextTooltip: React.FC<TextTooltipProps> = ({ title, children, side, align }: TextTooltipProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side} align={align}>
          {title}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

TextTooltip.displayName = "TextTooltip"

export { TextTooltip }
